module.exports = __webpack_public_path__ + "static/media/spain.57124beb.png";